<script setup>
import { computed, onMounted } from 'vue';
import { default as t } from '../../utils/translationStrings';

// Props.
const props = defineProps({
  user: {
    type: Object,
    required: true,
    default: () => {},
  },
});

// Computed.
const prefilledInputs = computed(() => {
  const drupalPrefix = 'edit-';

  return [
    {
      id: `${drupalPrefix}company-name`,
      value: props.user?.defaultBillingAddress?.company,
    },
    {
      id: `${drupalPrefix}first-name`,
      value: props.user?.firstName,
    },
    {
      id: `${drupalPrefix}last-name`,
      value: props.user?.lastName,
    },
    {
      id: `${drupalPrefix}email`,
      value: props.user?.email,
    },
    {
      id: `${drupalPrefix}phone`,
      value: props.user?.defaultBillingAddress?.phoneNumber,
    },
  ];
});

// Pre-fill form fields with user data.
// This is a Drupal form, so we are doing it on mounted.
onMounted(() => {
  // There is no this.$el in Vue 3; could also be replaced by a ref.
  const el = document.querySelector('.support-request');

  prefilledInputs.value.forEach((item) => {
    const input = el?.querySelector(`#${item.id}`);
    if (input) {
      input.value = item.value;
    }
  });
});
</script>

<template>
  <div class="support-request">
    <div class="dashboard-page__section">
      <!-- Form messages. -->
      <span class="dashboard-page__messages-placeholder"></span>

      <h2 class="dashboard-page__section-title">
        {{ t.dashboardPage.formSupport }}
      </h2>
      <p class="dashboard-page__section-description">
        {{ t.dashboardPage.formSupportInfo }}
      </p>
      <!-- Drupal webform slot. -->
      <slot></slot>
    </div>
  </div>
</template>
